import React from 'react';
import { Pie } from '@ant-design/plots';
import '../Chart.scss';

function CustomPieChart(props) {
  const { data = [], tooltipItems = [] } = props;

  const config = {
    data: data,
    angleField: 'value',
    colorField: 'name',
    paddingRight: 80,
    innerRadius: 0.6,
    tooltip: {
      title: 'label',
      items: tooltipItems,
    },
    label: {
      text: function content(_ref) {
        if (_ref?.value === 0) {
          return '';
        }
        return ''.concat(_ref.valueWithPercent ? _ref?.valueWithPercent : _ref?.value);
      },
      style: {
        fontWeight: 'bold',
      },
      position: function content(_ref) {
        if (
          Number(_ref?.valueWithPercent?.slice(0, -1)) <= 3 &&
          Number(_ref?.valueWithPercent?.slice(0, -1)) !== 0
        ) {
          return 'spider';
        }
      },
    },
    style: {
      stroke: '#fff',
      inset: 0,
    },
    color: {
      title: false,
      position: 'left',
      rowPadding: 6,
    },
  };
  return <Pie {...config} />;
}

export default CustomPieChart;
